import { Icon as FunctionalIcon } from "../../ui/Icon.js";
import { NEXUS_PROTOCOLS, PROTOCOL_SCRIP_MULTIPLIER } from "@zend/content";
import { pick, useT } from "../../i18n/index.js";
import { Button } from "../../ui/Button.js";
import { Timer } from "../../ui/Timer.js";
import { baseApi } from "../api.js";
import { useBase } from "../state.js";
import { Sheet } from "./shared.js";

/** Nexus Protocols: timed base-wide buffs for Credits or Scrip (R15). */
export function ProtocolPanel() {
  const t = useT();
  const base = useBase((s) => s.base);
  const run = useBase((s) => s.run);
  const setPanel = useBase((s) => s.setPanel);
  if (!base) return null;
  return (
    <Sheet title={t("base.protocols.title")} onClose={() => setPanel({ kind: "none" })} testId="protocol-panel">
      <p className="hint" style={{ marginTop: 0 }}>{t("base.protocols.hint")}</p>
      {NEXUS_PROTOCOLS.map((p) => {
        const active = base.protocols.find((a) => a.protocolId === p.id);
        return (
          <div key={p.id} className="list-row" style={{ display: "block" }} data-testid={`protocol-${p.id}`}>
            <div className="row">
              <span className="grow">
                <strong>{pick(p.name)}</strong>
                <div className="hint">
                  {t(`rsh.effect.${p.effect.key}`)} +{p.effect.pct}%
                </div>
              </span>
              {active ? (
                <span className="badge ok">
                  <FunctionalIcon name="dot" /> <Timer finishesAt={active.until} />
                </span>
              ) : null}
            </div>
            <div className="row" style={{ gap: 6, flexWrap: "wrap", marginTop: 6 }}>
              {p.durations.map((d) => (
                <span key={d.hours} className="row" style={{ gap: 4 }}>
                  <Button variant="gold" style={{ minHeight: 36 }} onClick={() => void run(() => baseApi.activateProtocol(p.id, d.hours, "credits"), t("base.toast.protocol"))} data-testid={`protocol-${p.id}-${d.hours}-credits`}>
                    {d.hours}h · {d.credits} ₵
                  </Button>
                  <Button style={{ minHeight: 36 }} onClick={() => void run(() => baseApi.activateProtocol(p.id, d.hours, "scrip"), t("base.toast.protocol"))} data-testid={`protocol-${p.id}-${d.hours}-scrip`}>
                    {d.hours}h · {d.credits * PROTOCOL_SCRIP_MULTIPLIER} $
                  </Button>
                </span>
              ))}
            </div>
          </div>
        );
      })}
    </Sheet>
  );
}
